import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {PaymentTokenAction} from '../controller/actions';
import { useParams } from 'react-router';
import { Grid, Header, Loader } from 'semantic-ui-react';

export default function PaymentPxPayPage(){

    const dispatch = useDispatch();
    const { paymentTokenUuid } = useParams();
    
    const paymentToken = useSelector((state) => state.paymentToken);

    useEffect(() => {
        if (paymentTokenUuid !== 'undefined' && paymentTokenUuid !== undefined && paymentTokenUuid !== null) {
            dispatch(new PaymentTokenAction().fetchWindcavePaymentByToken(paymentTokenUuid));
        }
    }, [paymentTokenUuid, dispatch]);

    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            {
                paymentToken && paymentToken.loader &&
        <Grid.Row>
            <Header size="large">Processing <Loader active inline /></Header>
        </Grid.Row>
            }
            {
                paymentToken && paymentToken.failed &&
        <Grid.Row>
            <Header size="large">Process failed</Header>
        </Grid.Row>
            }
            {
                paymentToken && paymentToken.success === true &&
        <Grid.Row>
            <Header size="large">Redirecting to payment portal <Loader active inline /></Header>
        </Grid.Row>
            }
        </Grid>
    );
}
